// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) {});

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)",
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
// document.addEventListener("DOMContentLoaded", function () {
//     if (typeof AOS === "undefined") return;
//     jQuery(document).on("sf:ajaxfinish", function () {
//         AOS.refreshHard();
//     });

//     var target = document.querySelector("#block-search-and-filter");
//     if (target) {
//         var resizeObserver = new ResizeObserver(function () {
//             AOS.refreshHard();
//         });
//         resizeObserver.observe(target);
//     }
// });

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 230;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Swiper slider cards with custom pagination
document.addEventListener("DOMContentLoaded", function () {
    var slides = document.querySelectorAll(
        ".slider-cards-swiper .swiper-slide",
    );
    var currentEl = document.querySelector(".progress-content__current");
    var totalEl = document.querySelector(".progress-content__total");
    var progressEl = document.querySelector(".custom-progress");

    var uniqueSlides = document.querySelectorAll(
        ".slider-cards-swiper .swiper-slide:not(.swiper-slide-duplicate)",
    ).length;
    if (totalEl) totalEl.textContent = uniqueSlides;

    var swiper = new Swiper(".slider-cards-swiper", {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
        on: {
            init: function (swiper) {
                updateCustomPagination(swiper);
            },
            slideChange: function (swiper) {
                updateCustomPagination(swiper);
            },
        },
    });
    updateCustomPagination({
        realIndex: 0,
    });

    function updateCustomPagination(swiper) {
        var realIndex =
            swiper && typeof swiper.realIndex !== "undefined"
                ? (swiper.realIndex % uniqueSlides) + 1
                : 1;
        if (currentEl) currentEl.textContent = realIndex;
        if (progressEl) {
            if (uniqueSlides > 1) {
                progressEl.style.width = (realIndex / uniqueSlides) * 100 + "%";
            } else {
                progressEl.style.width = "100%";
            }
        }
    }
});

// Testimonials Slider
jQuery(document).ready(function ($) {
    var $slider = $(".testimonials-slider");
    var $title = $(".block-slider-testimonials__container");
    var $controls = $(".slider-controls.mobile");
    var $wrapper = $(".container-arrows");

    if ($slider.length) {
        $slider.slick({
            slidesToShow: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            dots: false,
            prevArrow: $(".btn-arrow-prev"),
            nextArrow: $(".btn-arrow-next"),
        });

        AOS.refresh();

        function checkSlides() {
            var slickInstance = $slider.slick("getSlick");
            var totalSlides = slickInstance.$slides.length;
            var currentSlidesToShow = slickInstance.options.slidesToShow;

            if (totalSlides <= currentSlidesToShow) {
                $title.addClass("few-items");
                $controls.addClass("no-slider-controls");
                $wrapper.addClass("few-items");
            } else {
                $title.removeClass("few-items");
                $controls.removeClass("no-slider-controls");
                $wrapper.removeClass("few-items");
            }
        }

        $slider.on("init setPosition", function () {
            checkSlides();
        });

        $(window).on("resize orientationchange", function () {
            setTimeout(checkSlides, 200);
        });

        if ($slider.hasClass("slick-initialized")) {
            checkSlides();
        }
    }
});

// Our Work Slider
jQuery(document).ready(function ($) {
    if (typeof Swiper !== "undefined") {
        const swiper = new Swiper(".slider-our-work__container", {
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                nextEl: ".slider-our-work__controls .swiper-button-next",
                prevEl: ".slider-our-work__controls .swiper-button-prev",
            },
            breakpoints: {
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
            },
        });
    }
});

//Global Our Work Slider
jQuery(document).ready(function ($) {
    if (typeof Swiper !== "undefined") {
        const swiper = new Swiper(".global-slider-our-work__container", {
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                nextEl: ".global-slider-our-work__controls .swiper-button-next",
                prevEl: ".global-slider-our-work__controls .swiper-button-prev",
            },
            breakpoints: {
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
            },
        });
    }
});

/* side by side accordion */
document.addEventListener("DOMContentLoaded", function () {
    const wrappers = document.querySelectorAll(".js-side-by-side-accordion");
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
        const items = wrapper.querySelectorAll(".side-by-side-accordion__item");
        if (!items.length) return;

        const section = wrapper.closest(".side-by-side-accordion");
        if (!section) return;

        const bgEl = section.querySelector(".js-side-by-side-accordion-bg");
        if (!bgEl) return;

        function setBg(imageUrl) {
            bgEl.style.setProperty(
                "--accordion-bg-img",
                imageUrl ? `url("${imageUrl}")` : "none",
            );
        }

        const firstBg = items[0].getAttribute("data-bg") || "";
        let activeBg = firstBg;
        const canHover =
            window.matchMedia &&
            window.matchMedia("(hover: hover) and (pointer: fine)").matches;

        setBg(firstBg);

        items.forEach(function (item) {
            const header = item.querySelector(
                ".side-by-side-accordion__item-header",
            );
            if (!header) return;

            const itemBg = item.getAttribute("data-bg") || firstBg;

            header.addEventListener("click", function () {
                const wasActive = item.classList.contains("is-active");
                items.forEach((i) => i.classList.remove("is-active"));

                activeBg = wasActive ? firstBg : itemBg;
                if (!wasActive) {
                    item.classList.add("is-active");
                }
                setBg(activeBg);
            });

            if (canHover) {
                item.addEventListener("mouseenter", function () {
                    setBg(itemBg);
                });

                item.addEventListener("mouseleave", function () {
                    setBg(activeBg);
                });
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".stack-esd");

    function equalizeHeights() {
        items.forEach((item) => {
            item.style.height = "auto";
        });

        let max = 0;
        items.forEach((item) => {
            const h = item.offsetHeight;
            if (h > max) max = h;
        });

        items.forEach((item) => {
            item.style.height = max + "px";
        });
    }

    equalizeHeights();

    let resizeTimeout;
    window.addEventListener("resize", function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(equalizeHeights, 150);
    });
});
jQuery(document).ready(function ($) {
    $(".features-slick").each(function () {
        var $slick = $(this);

        var $controls = $slick
            .closest(".features-slider-wrapper")
            .next(".container-pagination")
            .find(".slider-controls");

        if (!$controls.length) {
            $controls = $slick
                .closest("section")
                .find(".container-pagination .slider-controls")
                .first();
        }

        var $current = $controls.find(".slider-pagination .current");
        var $total = $controls.find(".slider-pagination .total");
        var $prevArrow = $controls.find(".arrow-prev");
        var $nextArrow = $controls.find(".arrow-next");

        $slick.on("init", function (event, slick) {
            if ($total.length) $total.text(slick.slideCount);
            if ($current.length) $current.text(slick.currentSlide + 1);
        });

        $slick.on("afterChange", function (event, slick, currentSlide) {
            if ($current.length) $current.text(currentSlide + 1);
        });

        $slick.slick({
            infinite: true,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "300px",
            arrows: true,
            dots: false,
            prevArrow: $prevArrow.length ? $prevArrow : null,
            nextArrow: $nextArrow.length ? $nextArrow : null,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerPadding: "160px",
                    },
                },
                {
                    breakpoint: 991,
                    settings: {
                        centerPadding: "0px",
                    },
                },
            ],
        });

        if ($slick.hasClass("slick-initialized")) {
            var slickObj = $slick.get(0).slick;
            if (slickObj) {
                if ($total.length) $total.text(slickObj.slideCount);
                if ($current.length) $current.text(slickObj.currentSlide + 1);
            }
        }
    });
});
/*Pattern gallery*/
(function () {
    document.addEventListener("DOMContentLoaded", function () {
        const galleries = document.querySelectorAll("[data-patterns-gallery]");
        if (!galleries.length) return;

        galleries.forEach(function (gallery) {
            const track = gallery.querySelector(".patterns-gallery__track");
            const slides = Array.from(
                gallery.querySelectorAll(".patterns-gallery__slide"),
            );
            const thumbs = Array.from(
                gallery.querySelectorAll(".patterns-gallery__thumb-btn"),
            );
            const viewport = gallery.querySelector(
                ".patterns-gallery__viewport",
            );

            if (!track || !slides.length) return;

            let currentIndex = 0;
            const totalSlides = slides.length;

            function goToSlide(index) {
                if (index < 0) index = totalSlides - 1;
                if (index >= totalSlides) index = 0;

                currentIndex = index;
                const offset = -index * 100;

                track.style.transform = "translateX(" + offset + "%)";

                slides.forEach(function (s, i) {
                    s.classList.toggle("is-active", i === index);
                });

                thumbs.forEach(function (t, i) {
                    t.classList.toggle("is-active", i === index);
                });
            }

            thumbs.forEach(function (btn) {
                btn.addEventListener("click", function () {
                    const idx = parseInt(
                        btn.getAttribute("data-slide-index"),
                        10,
                    );
                    if (!isNaN(idx)) {
                        goToSlide(idx);
                    }
                });
            });

            let startX = 0;
            let isDragging = false;

            if (viewport) {
                viewport.addEventListener("touchstart", function (e) {
                    if (!e.touches || !e.touches.length) return;
                    isDragging = true;
                    startX = e.touches[0].clientX;
                });

                viewport.addEventListener("touchend", function (e) {
                    if (!isDragging) return;
                    isDragging = false;

                    const endX = e.changedTouches[0].clientX;
                    const diff = endX - startX;

                    if (Math.abs(diff) > 50) {
                        if (diff > 0) {
                            goToSlide(currentIndex - 1);
                        } else {
                            goToSlide(currentIndex + 1);
                        }
                    }
                });
            }

            goToSlide(0);
        });
    });
})();

document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".tabs-products-btn");
    const panels = document.querySelectorAll(".tabs-products-panel");

    const swipers = {};

    document
        .querySelectorAll(".product-gallery-swiper")
        .forEach((swiperEl, i) => {
            const scrollbarEl = swiperEl.querySelector(".swiper-scrollbar");
            swipers[i] = new Swiper(swiperEl, {
                slidesPerView: 1,
                loop: false,
                navigation: false,
                pagination: false,
                scrollbar: {
                    el: scrollbarEl,
                    draggable: true,
                    hide: false,
                },
            });
        });

    buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
            let target = btn.dataset.tab;

            buttons.forEach((b) => b.classList.remove("active"));
            panels.forEach((p) => p.classList.remove("active"));

            btn.classList.add("active");
            const panel = document.getElementById(target);
            panel.classList.add("active");

            // RESET + UPDATE
            panel
                .querySelectorAll(".product-gallery-swiper")
                .forEach((swiperEl) => {
                    const id = Array.from(
                        document.querySelectorAll(".product-gallery-swiper"),
                    ).indexOf(swiperEl);

                    if (swipers[id]) {
                        swipers[id].slideTo(0, 0); // Reset
                        swipers[id].update();
                        swipers[id].scrollbar.updateSize();
                    }
                });
        });
    });
});
jQuery(document).ready(function ($) {
    if (typeof Swiper !== "undefined") {
        const swiper = new Swiper(".slider-related__container", {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: ".slider-related__controls .swiper-button-next",
                prevEl: ".slider-related__controls .swiper-button-prev",
            },
            breakpoints: {
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
            },
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const headers = document.querySelectorAll(
        '.product-specs__content[role="button"]',
    );

    const toggleHeader = (header) => {
        const icon = header.querySelector(".downloads-toggle");
        const currentDownloads = header.querySelector(
            ".product-specs__downloads",
        );
        if (!currentDownloads) return;

        document
            .querySelectorAll(".product-specs__downloads:not(.closed)")
            .forEach((openBox) => {
                if (openBox !== currentDownloads) {
                    openBox.classList.add("closed");
                    const otherHeader = openBox.closest(
                        '.product-specs__content[role="button"]',
                    );
                    if (!otherHeader) return;
                    otherHeader
                        .querySelector(".downloads-toggle")
                        ?.classList.remove("open");
                    otherHeader.setAttribute("aria-expanded", "false");
                }
            });

        const isOpen = !currentDownloads.classList.contains("closed");

        if (isOpen) {
            currentDownloads.classList.add("closed");
            icon?.classList.remove("open");
            header.setAttribute("aria-expanded", "false");
        } else {
            currentDownloads.classList.remove("closed");
            icon?.classList.add("open");
            header.setAttribute("aria-expanded", "true");
        }
    };

    headers.forEach((header) => {
        header.addEventListener("click", function (e) {
            if (e.target.closest("a")) return;
            toggleHeader(header);
        });

        header.addEventListener("keydown", function (e) {
            if (e.target !== header) return;
            if (e.key !== "Enter" && e.key !== " ") return;
            e.preventDefault();
            toggleHeader(header);
        });
    });
});
document.addEventListener("DOMContentLoaded", function () {
    const toggleButtons = document.querySelectorAll(".product-toggle");

    toggleButtons.forEach((button) => {
        const contentBox = button.closest(".product-type");
        if (!contentBox) return;

        const downloads = contentBox.querySelector(".product-type__downloads");
        if (!downloads) return;

        button.addEventListener("click", function () {
            downloads.classList.toggle("closed");
            button.classList.toggle("open");

            const expanded = button.getAttribute("aria-expanded") === "true";
            button.setAttribute("aria-expanded", !expanded);
        });
    });
});

//Sticky anchorlinks
document.addEventListener("DOMContentLoaded", function () {
    const anchorLinks = document.querySelectorAll(".anchorlinks a");
    const sections = [];
    const headerOffset = 200;
    let scrollingByClick = false;

    // Collect all target sections
    anchorLinks.forEach((link) => {
        const href = link.getAttribute("href");
        if (href && href.startsWith("#")) {
            const section = document.querySelector(href);
            if (section) {
                sections.push({
                    link: link,
                    section: section,
                    id: href,
                });
            }
        }
    });

    // Smooth scroll on click
    anchorLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            const href = this.getAttribute("href");
            if (href && href.startsWith("#")) {
                e.preventDefault();
                const targetSection = document.querySelector(href);
                if (targetSection) {
                    const elementPosition =
                        targetSection.getBoundingClientRect().top;
                    const offsetPosition =
                        elementPosition + window.pageYOffset - headerOffset;

                    scrollingByClick = true;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });

                    anchorLinks.forEach((l) => l.classList.remove("active"));
                    this.classList.add("active");

                    setTimeout(() => {
                        scrollingByClick = false;
                    }, 500);
                }
            }
        });
    });

    // Active state on scroll
    const observerOptions = {
        root: null,
        rootMargin: `-${headerOffset}px 0px -50% 0px`,
        threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
        if (scrollingByClick) return;
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                anchorLinks.forEach((l) => l.classList.remove("active"));

                const activeLink = sections.find(
                    (item) => item.section === entry.target,
                );
                if (activeLink) {
                    activeLink.link.classList.add("active");
                }
            }
        });
    }, observerOptions);

    sections.forEach((item) => {
        observer.observe(item.section);
    });

    // Sticky Bar Logic
    const stickyBar = document.querySelector(".sticky-anchorlinks");
    if (stickyBar) {
        const topOffset = 140;

        const placeholder = document.createElement("div");
        placeholder.classList.add("sticky-placeholder");
        placeholder.style.height = stickyBar.offsetHeight + "px";
        placeholder.style.display = "none";
        placeholder.style.width = "100%";
        stickyBar.parentNode.insertBefore(placeholder, stickyBar);

        let stickyOriginalPos =
            stickyBar.getBoundingClientRect().top + window.scrollY;

        const handleScroll = () => {
            if (window.innerWidth < 992) {
                stickyBar.classList.remove("is-fixed");
                placeholder.style.display = "none";
                return;
            }
            const scrollY = window.scrollY;
            // Check if we have scrolled past the original position
            if (scrollY >= stickyOriginalPos - topOffset) {
                stickyBar.classList.add("is-fixed");
                placeholder.style.display = "block";
            } else {
                stickyBar.classList.remove("is-fixed");
                placeholder.style.display = "none";
            }
        };

        const handleResize = () => {
            // Reset to calculate correct position
            stickyBar.classList.remove("is-fixed");
            placeholder.style.display = "none";
            stickyOriginalPos =
                stickyBar.getBoundingClientRect().top + window.scrollY;
            placeholder.style.height = stickyBar.offsetHeight + "px";
            handleScroll();
        };

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);

        handleScroll();
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".timeline-tab");
    const groups = document.querySelectorAll(".events-group");

    tabs.forEach((tab) => {
        tab.addEventListener("click", function () {
            const target = this.dataset.period;

            tabs.forEach((t) => t.classList.remove("active"));
            groups.forEach((g) => g.classList.remove("active"));

            this.classList.add("active");
            document.getElementById(target).classList.add("active");
        });
    });
});
document
    .querySelectorAll(".heading-with-side-icon__group> .wp-block-group")
    .forEach((el) => {
        Object.assign(el.dataset, {
            aosDuration: "300",
            aos: "fade-zoom-in",
            aosOffset: "50",
            aosDelay: "0",
        });
    });

//single ong form technical post
document.addEventListener("DOMContentLoaded", function () {
    const tocLinks = document.querySelectorAll(
        ".technical-post__toc .toc-link",
    );
    const sections = [];

    tocLinks.forEach((link) => {
        const href = link.getAttribute("href");
        if (href && href.startsWith("#")) {
            try {
                const section = document.querySelector(href);
                if (section) {
                    sections.push({
                        link,
                        section,
                    });
                }
            } catch (e) {
                console.warn("Invalid selector:", href);
            }
        }
    });

    tocLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            const href = this.getAttribute("href");
            if (href && href.startsWith("#")) {
                const target = document.querySelector(href);
                if (target) {
                    tocLinks.forEach((l) => l.classList.remove("active"));
                    this.classList.add("active");

                    const headerOffset = 150;
                    const elementPosition = target.getBoundingClientRect().top;
                    const offsetPosition =
                        elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                }
            }
        });
    });

    const observerOptions = {
        root: null,
        rootMargin: "-150px 0px -60% 0px",
        threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                tocLinks.forEach((l) => l.classList.remove("active"));

                const activeItem = sections.find(
                    (item) => item.section === entry.target,
                );
                if (activeItem) {
                    activeItem.link.classList.add("active");
                }
            }
        });
    }, observerOptions);

    sections.forEach((item) => {
        observer.observe(item.section);
    });
});
// Slider Project Gallery
jQuery(document).ready(function ($) {
    if (typeof Swiper !== "undefined") {
        new Swiper(".gallery-content__container", {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: ".swiper-gallery-next",
                prevEl: ".swiper-gallery-prev",
            },
            breakpoints: {
                542: {
                    slidesPerView: "auto",
                    spaceBetween: 40,
                },
            },
        });
    }
});

// Search & Filter: Scroll to top on pagination
function scrollToResults() {
    var target = jQuery(".sf-results-wrapper");
    if (!target.length) target = jQuery("main");

    if (target.length) {
        var headerHeight = jQuery("header.header-site").outerHeight() || 100;
        jQuery("html, body").animate(
            {
                scrollTop: target.offset().top - headerHeight - 30,
            },
            500,
        );
    }
}
jQuery(document).on("click", ".pagination a", function () {
    scrollToResults();
});

jQuery(document).on("sf:ajaxfinish", function () {
    scrollToResults();
});

jQuery(document).ready(function ($) {
    if (window.location.href.indexOf("/page/") > -1) {
        setTimeout(function () {
            scrollToResults();
        }, 500);
    }
});

//transcript
(function () {
    document.addEventListener("DOMContentLoaded", function () {
        const detailsList = document.querySelectorAll(
            ".block-transcript__details",
        );

        detailsList.forEach((detail) => {
            const summary = detail.querySelector("summary");
            const content = detail.querySelector(".content");
            if (!summary || !content) return;

            detail.style.overflow = "hidden";
            detail.style.transition = "max-height 0.8s ease";

            detail.open = false;

            const setHeight = (isOpen) => {
                const summaryHeight = summary.offsetHeight;
                const contentHeight = content.scrollHeight;

                if (isOpen) {
                    detail.style.maxHeight =
                        summaryHeight + contentHeight + "px";
                } else {
                    detail.style.maxHeight = summaryHeight + "px";
                }
            };

            setHeight(false);

            summary.addEventListener("click", function (e) {
                e.preventDefault();

                const isOpen = detail.open;
                const summaryHeight = summary.offsetHeight;
                const contentHeight = content.scrollHeight;

                if (!isOpen) {
                    detail.open = true;
                    detail.style.maxHeight = summaryHeight + "px";

                    requestAnimationFrame(() => {
                        detail.style.maxHeight =
                            summaryHeight + contentHeight + "px";
                    });
                } else {
                    detail.style.maxHeight =
                        summaryHeight + contentHeight + "px";

                    requestAnimationFrame(() => {
                        detail.style.maxHeight = summaryHeight + "px";
                    });

                    const onTransitionEnd = (ev) => {
                        if (ev.propertyName !== "max-height") return;
                        detail.open = false;
                        detail.removeEventListener(
                            "transitionend",
                            onTransitionEnd,
                        );
                    };

                    detail.addEventListener("transitionend", onTransitionEnd);
                }
            });
            window.addEventListener("resize", function () {
                setHeight(detail.open);
            });
        });
    });
})();
// Accesibility innerblocks
document.addEventListener("DOMContentLoaded", function () {
    const innerBlockButtons = document.querySelectorAll(
        ".acf-innerblocks-container .wp-block-button__link, .acf-innerblocks-container .btn-site, .innerblock .wp-block-button__link, .innerblock .btn-site, .wp-block-button__link.wp-element-button, .card-result,.search-filter-field__input .search-filter-input-radio",
    );

    innerBlockButtons.forEach((btn) => {
        if (btn.tagName === "A" && !btn.getAttribute("role")) {
            btn.setAttribute("role", "button");
        }

        if (!btn.getAttribute("tabindex")) {
            btn.setAttribute("tabindex", "0");
        }

        const textContent = btn.textContent.trim();
        if (!textContent && !btn.getAttribute("aria-label")) {
            btn.setAttribute("aria-label", "Button");
        }
    });
});
//Project timeline
jQuery(function ($) {
    function staticworx_drawTimeline() {
        const $timeline = $(".block-project-timeline .js-content-timeline");
        const $boxes = $(".block-project-timeline .js-content-timeline__box");

        if ($boxes.length <= 1) return;

        const $firstCircle = $boxes.first().find(".js-circle");
        const $lastCircle = $boxes.last().find(".js-circle");

        const circleRadius = $firstCircle.outerHeight() / 2;
        const timelineTop = $timeline.offset().top;

        // actual center of the first and last
        const firstCenter =
            $firstCircle.offset().top - timelineTop + circleRadius;
        const lastCenter =
            $lastCircle.offset().top - timelineTop + circleRadius;

        const lineHeight = lastCenter - firstCenter;

        $timeline.find(".js-timeline-line").css({
            position: "absolute",
            top: firstCenter + "px",
            left: circleRadius + "px",
            height: lineHeight + "px",
            width: "2px",
            backgroundColor: "#99acb9",
            zIndex: 0,
        });
    }

    // Run when loading
    staticworx_drawTimeline();

    // Recalculate in resize with debounce
    let resizeTimer;
    $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(staticworx_drawTimeline, 200);
    });
});

// Logos Slider
jQuery(document).ready(function ($) {
    var $slider = $(".logos-slider");
    var $title = $(".block-slider-logos__container");
    var $controls = $(".slider-controls.mobile");
    var $wrapper = $(".container-arrows2");

    if ($slider.length) {
        $slider.slick({
            slidesToShow: 7,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: true,
            draggable: true,
            swipe: true,
            touchMove: true,
            dots: false,
            prevArrow: $(".prev-arrow-logo"),
            nextArrow: $(".next-arrow-logo"),
            centerMode: true,
            centerPadding: "0px",
            swipeToSlide: true,
            touchThreshold: 10,
            responsive: [
                {
                    breakpoint: 1480,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ],
        });

        AOS.refresh();

        function checkSlides_logo() {
            var slickInstance = $slider.slick("getSlick");
            var totalSlides = slickInstance.$slides.length;
            var currentSlidesToShow = slickInstance.options.slidesToShow;

            if (totalSlides <= currentSlidesToShow) {
                $title.addClass("few-items");
                $controls.addClass("no-slider-controls");
                $wrapper.addClass("few-items");
                $slider.slick("slickSetOption", "draggable", false, false);
            } else {
                $title.removeClass("few-items");
                $controls.removeClass("no-slider-controls");
                $wrapper.removeClass("few-items");
                $slider.slick("slickSetOption", "draggable", true, false);
            }
        }

        $slider.on("init setPosition", function () {
            checkSlides_logo();
        });

        $(window).on("resize orientationchange", function () {
            setTimeout(checkSlides_logo, 200);
        });

        if ($slider.hasClass("slick-initialized")) {
            checkSlides_logo();
        }
    }
});
window.initStatsResizer = function (counters) {
    if (!counters || !Array.isArray(counters)) return;

    const adjustFontSizes = () => {
        // 1. Reset all font sizes first to get natural layout (CSS/SASS)
        counters.forEach((counter) => {
            const el = document.getElementById(counter.id);
            if (el) el.style.fontSize = "";
        });

        let minFontSize = 1000;
        const results = [];
        let anyOverflow = false;

        counters.forEach((counter) => {
            const el = document.getElementById(counter.id);
            if (!el) return;

            const parent = el.parentElement;
            const container = parent.parentElement;

            if (!container || !parent) return;

            // Measure available space
            const containerStyle = window.getComputedStyle(container);
            const containerWidth =
                container.clientWidth -
                parseFloat(containerStyle.paddingLeft) -
                parseFloat(containerStyle.paddingRight);

            let siblingsWidth = 0;
            const prefix = parent.querySelector(".stat__prefix");
            const suffix = parent.querySelector(".stat__suffix");
            if (prefix) siblingsWidth += prefix.offsetWidth;
            if (suffix) siblingsWidth += suffix.offsetWidth;

            let gaps = 0;
            if (prefix && suffix) gaps = 20;
            else if (prefix || suffix) gaps = 10;

            const availableWidth = containerWidth - siblingsWidth - gaps;

            const dummy = document.createElement("span");
            dummy.style.visibility = "hidden";
            dummy.style.position = "absolute";
            dummy.style.whiteSpace = "nowrap";

            const computed = window.getComputedStyle(el);
            dummy.style.fontFamily = computed.fontFamily;
            dummy.style.fontWeight = computed.fontWeight;
            dummy.style.letterSpacing = computed.letterSpacing;
            dummy.style.fontSize = computed.fontSize;
            dummy.style.textTransform = computed.textTransform;

            let valStr = String(counter.stat);
            // Handling separator if present in options
            if (counter.options && counter.options.separator) {
                const delimiter = counter.options.separator;
                const parts = valStr.split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
                valStr = parts.join(".");
            }
            dummy.textContent = valStr;

            document.body.appendChild(dummy);
            const dummyWidth = dummy.offsetWidth;
            const currentFontSize = parseFloat(computed.fontSize);
            const margin = 5;

            let calculatedSize = currentFontSize;
            if (dummyWidth > availableWidth - margin) {
                const ratio = (availableWidth - margin) / dummyWidth;
                calculatedSize = Math.floor(currentFontSize * ratio);
                anyOverflow = true;
            }

            results.push({
                id: counter.id,
                size: calculatedSize,
            });

            if (calculatedSize < minFontSize) {
                minFontSize = calculatedSize;
            }

            document.body.removeChild(dummy);
        });

        const shouldApplySync = counters.length >= 4 || anyOverflow;
        const finalSize = Math.max(20, minFontSize);

        if (shouldApplySync) {
            results.forEach((item) => {
                const el = document.getElementById(item.id);
                if (el) {
                    el.style.fontSize = finalSize + "px";
                }
            });
        }
    };

    let timeout;
    window.addEventListener("resize", () => {
        clearTimeout(timeout);
        timeout = setTimeout(adjustFontSizes, 100);
    });

    // Run initial adjustment
    setTimeout(adjustFontSizes, 100);
};

document.querySelectorAll(".faq-item").forEach((item) => {
    item.addEventListener("toggle", (event) => {
        if (event.target.open) {
            event.target.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const accordionItems = document.querySelectorAll(
        ".side-by-side-accordion__item",
    );

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === "class") {
                const item = mutation.target;

                if (item.classList.contains("is-active")) {
                    const header = item.querySelector(
                        ".side-by-side-accordion__item-header",
                    );

                    if (header) {
                        header.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                    }
                }
            }
        });
    });

    accordionItems.forEach((item) => {
        observer.observe(item, {
            attributes: true,
            attributeFilter: ["class"],
        });
    });
});
